import { SplitPanel, SplitPanelProps } from '@infotech-soe/erp-ui-kit';
import React, { useMemo } from 'react';

import {
  HorizontallyStackedDatasetLayoutViewModel,
  VerticallyStackedDatasetLayoutViewModel,
} from '../../../../services/category/view-model/DatasetLayoutViewModel';
import UniqueId from '../../../../services/uid/UniqueId';
import CategoryLayoutElementContainer from '../CategoryLayoutElementContainer';

export interface CategorySplitPanelProps extends Pick<
  SplitPanelProps,
  'horizontal' | 'onResize'
> {
  categoryId: UniqueId;
  element:
    | HorizontallyStackedDatasetLayoutViewModel
    | VerticallyStackedDatasetLayoutViewModel;
  showCommands: boolean;
}

const CategorySplitPanel: React.FC<CategorySplitPanelProps> = ({
  categoryId,
  element,
  horizontal,
  showCommands,
  onResize,
}) => {
  const panes = React.Children.toArray(element.children);

  const firstPaneSize = useMemo(() => {
    let scales = element.initialScale;

    if (scales.length < panes.length) {
      scales = scales.slice();
      while (scales.length < panes.length) {
        scales.push(1);
      }
    }

    const ratio = scales[0] / Math.floor(scales.reduce((x, y) => x + y));
    return Math.floor(ratio * 100);
  }, [element.initialScale, panes.length]);

  if (panes.length === 0) {
    return null;
  }

  if (panes.length === 1) {
    return panes[0] as React.ReactElement;
  }

  return (
    <SplitPanel
      defaultSize={firstPaneSize}
      horizontal={horizontal}
      onResize={onResize}
    >
      {element.children.map(id => (
        <CategoryLayoutElementContainer
          key={id}
          categoryId={categoryId}
          elementId={id}
          showCommands={showCommands}
        />
      ))}
    </SplitPanel>
  );
};

export default CategorySplitPanel;
